
import { computed, defineComponent, PropType, Ref, ref, watch, reactive, toRefs } from 'vue'
import QuantityContainer from '@/pages/Dashboard/components/QuantityContainer.vue'
import { $get } from '@/utils'
import SimpleLink from '@/components/SimpleLink.vue'
import { useStore } from 'vuex'
// import { Entry } from '@Protium/vue-ozone-utils'
import { format } from '@/utils/template'

// TODO: Now using different layout types for new and old design, change all layouts to new design later?
enum ItemLayoutType {
  Product = 'product',
  Location = 'location',
  Receive = 'receive'
}

export default defineComponent({
  name: 'SelectableItem',
  components: { QuantityContainer, SimpleLink },
  props: {
    payload: {
      type: [Object, String],
      required: true
    },
    index: {
      type: [String, Number]
    },
    id: {
      type: String,
      default: 'sys.id'
    },
    cache: {
      type: Array as PropType<Array<any>>
    },
    meta: {
      type: [String, Number, Array, Object] as PropType<any>,
    },
    selected: {
      type: [Boolean, Number],
      default: false
    },
    active: {
      type: [Boolean, String, Array, Object],
      default: false
    },
    activeOnFocus: {
      type: Boolean,
      default: false
    },
    expandable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    layout: {
      type: String as PropType<Lowercase<ItemLayoutType>>
    },
    subtitle: {
      type: String,
      required: false,
      default: ''
    },
    simpleLink: {
      type: Boolean,
      default: false
    },
    quantity: {
      type: Number,
    },
    partial: {
      type: Number
    }
  },
  emits: ['update:selected', 'select', 'update:active', 'update:cache', 'expand'],
  setup (props, { emit }) {
    const $store = useStore()
    const focused = ref(false)
    const settings = $store.getters['User/Settings']

    const currentCache = computed({
      get: () => props.cache,
      set: (value) => {
        emit('update:cache', value)
      }
    })

    // q-dialog
    const prompt = ref()
    const serial = ref()

    function remove () {
      emit('select', typeof props.payload === 'string' ? props.payload : $get(props.payload, props.id), false)
    }

    function select () {
      emit('select', typeof props.payload === 'string' ? props.payload : $get(props.payload, props.id), true)
    }

    const identifier = computed(() => typeof props.payload === 'string' ? props.payload : $get(props.payload, props.id))

    watch(() => props.active, active => {
      if (active === false || (active as Ref).value === false) focused.value = false
    })

    return {
      format,
      prompt,
      serial,
      select,
      remove,
      identifier,
      focused,
      settings,
      currentCache,
      setActive: value => {
        emit('update:active', value ?? false)
        focused.value = value ?? false
      },
      isActive: computed(() => focused.value || (typeof props.active === 'boolean'
        ? props.active
        : Array.isArray(props.active)
          ? props.active.includes(identifier)
          : typeof props.active === 'object'
            ? $get(props.active, props.id) === identifier.value
            : props.active === identifier.value)),
      ItemLayoutType,
    }
  }
})
